import React from 'react';
import './style.scss';

class Header extends React.Component {
  headerRef = React.createRef();

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const { current } = this.headerRef;
    if (current) {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        current.classList.add('small');
      } else {
        current.classList.remove('small');
      }
    }
  }

  render() {
    return (
      <header
        className="header-wrapper"
        ref={this.headerRef}
      >
        <div className="title-wrapper">
          <div className="title">{this.props.title}</div>
          <div className="subtitle">{this.props.subTitle}</div>
        </div>
        <a
          className="github-icon-wrapper"
          href={this.props.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="github-icon"/>
        </a>
      </header>
    );
  }
}

export default Header;
